import { z } from 'zod';

export const enableSSOSchema = z.object({
  entraIdTenantId: z
    .string()
    .optional()
    .refine(
      (val) => !val || (val.length > 0 && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(val)),
      'Tenant ID må være en gyldig UUID (hvis angitt)'
    ),
  entraIdClientId: z
    .string()
    .optional()
    .refine(
      (val) => !val || (val.length > 0 && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(val)),
      'Client ID må være en gyldig UUID (hvis angitt)'
    ),
  entraIdClientSecret: z
    .string()
    .optional()
    .refine(
      (val) => !val || val.length >= 32,
      'Client Secret må være minst 32 tegn (hvis angitt)'
    ),
  entraIdDomain: z
    .string()
    .optional()
    .refine(
      (val) => !val || /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/.test(val),
      'Ugyldig domenenavn (må være et gyldig domene som example.com eller mail.example.com)'
    ),
});

export type EnableSSOFormData = z.infer<typeof enableSSOSchema>;
